module.exports = __webpack_public_path__ + "static/media/James.4ca8e01d.JPG";